import React, {Fragment} from 'react';
import dateformat from 'dateformat';
import ViewForm, {ViewFormField} from './ViewForm';
import {formatPhoneNumber} from '../../../helpers/string';
import {GridColumn} from '@atlaskit/page';
import {TextField, DatePickerField, SelectField} from '../../../components/FormFields';
import Button, { ButtonGroup } from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {EditViewContext} from './EditViewContext';
import i18n from 'i18next';
import {Trans} from 'react-i18next';

export const ClientInfoFields = ({
  fullName,
  dateOfBirth,
  gender,
  dateOfLicense,
  phone,
  email,
  onChange,
  fetching,
  dictionaries,
  getDictionaries,
}) => (
  <Fragment>
    <GridColumn medium={12}>
      <TextField
        name='fullName'
        label={i18n.t('clients:Full name')}
        placeholder={i18n.t('clients:Enter full name')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={fullName}
      />
    </GridColumn>
    <GridColumn medium={4}>
      <DatePickerField
        name='dateOfBirth'
        label={i18n.t('clients:Date of birth')}
        placeholder={i18n.t('ddmmyyyy')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={dateOfBirth}
      />
    </GridColumn>
    <GridColumn medium={4}>
      <SelectField 
        name='gender'
        label={i18n.t('clients:Gender')}
        placeholder={i18n.t('clients:Select gender')}
        isMulty={false}
        value={gender}
        required={true}
        onChange={onChange}
        data={dictionaries.genders.data}
        fetching={dictionaries.genders.fetching}
        getData={getDictionaries('genders')}
        isDisabled={fetching}
      />
    </GridColumn>
    <GridColumn medium={12}></GridColumn>
    <GridColumn medium={4}>
      <DatePickerField
        name='dateOfLicense'
        label={i18n.t('clients:Driving license issue date')}
        placeholder={i18n.t('ddmmyyyy')}
        required={false}
        onChange={onChange}
        isDisabled={fetching}
        value={dateOfLicense}
      />
    </GridColumn>
    <GridColumn medium={12}></GridColumn>
    <GridColumn medium={4}>
      <TextField
        name='phone'
        label={i18n.t('clients:Phone')}
        placeholder={i18n.t("clients:Enter client's phone number")}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={phone}
      />
    </GridColumn>
    <GridColumn medium={4}>
      <TextField
        name='email'
        label={i18n.t('clients:E-mail')}
        placeholder={i18n.t("clients:Enter client's e-mail")}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={email}
      />
    </GridColumn>
  </Fragment>
)

const ClientInfoEditForm = ({
  fullName,
  dateOfBirth,
  gender,
  dateOfLicense,
  phone,
  email,
  onChange,
  dictionaries,
  getDictionaries,
  fetching,
  onCancel,
}) => (
  <Fragment>
    <ClientInfoFields
      fullName={fullName}
      dateOfBirth={dateOfBirth}
      gender={gender}
      dateOfLicense={dateOfLicense}
      phone={phone}
      email={email}
      onChange={onChange}
      dictionaries={dictionaries}
      getDictionaries={getDictionaries}
    />
    <GridColumn medium={12}>
      <FormFooter>
        <ButtonGroup>
          <Button appearance='subtle' isDisabled={fetching} onClick={onCancel}>
            <Trans>
              Cancel
            </Trans>
          </Button>
          <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='danger'>
            <Trans>
              Save
            </Trans>
          </Button>
        </ButtonGroup>
      </FormFooter>
    </GridColumn>
  </Fragment>
)

const ClientInfoViewForm = ({fullName, dateOfBirth, gender, dateOfLicense, phone, email}) => (
  <Fragment>
    <ViewFormField label={i18n.t('clients:Full name')} value={fullName} gridColumn={12} />
    <ViewFormField label={i18n.t('clients:Date of birth')} value={dateformat(dateOfBirth, 'dd.mm.yyyy')} gridColumn={4} />
    <ViewFormField label={i18n.t('clients:Gender')} value={gender.name} gridColumn={4} />
    <ViewFormField label={i18n.t('clients:Driving license issue date')} value={dateOfLicense!=null?dateformat(dateOfLicense, 'dd.mm.yyyy'):null} gridColumn={12} />
    <ViewFormField label={i18n.t('clients:Phone')} value={formatPhoneNumber(phone)} gridColumn={4} />
    <ViewFormField label={i18n.t('clients:E-mail')} value={email} gridColumn={4} />
  </Fragment>
)

export default props => {
  const formName = 'client';
  return (
    <EditViewContext.Consumer>
      {({edit, permissions, onChangeEditMode, onChange}) => permissions.info && (
        <ViewForm
          formName={formName}
          title={i18n.t('clients:Client')}
          actionName={permissions.info.edit && i18n.t('Edit')}
          action={onChangeEditMode(formName)}
          editMode={edit === formName}
        >
          {edit === formName 
            ? <ClientInfoEditForm {...props} onChange={onChange} />
            : <ClientInfoViewForm {...props} />
          }
        </ViewForm>
      )}
    </EditViewContext.Consumer>
  );
}
